// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Oceanside Hero Component Styles */
.hero--oceanside {
  position: relative;
  width: 100%;
  min-height: 700px;
  overflow: hidden;
  background-color: #000;
  display: flex;
  align-items: center;
  padding: 60px 0;
}

/* Background Media */
.hero--oceanside .hero__media {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.hero--oceanside .hero__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.hero--oceanside .hero__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0.6) 50%,
    rgba(0, 0, 0, 0.3) 100%
  );
  z-index: 2;
}

/* Container */
.hero--oceanside .hero__container {
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  min-height: 600px;
}

/* Left Content */
.hero--oceanside .hero__content {
  flex: 1;
  max-width: 600px;
  text-align: left;
}

/* Typography */
.hero--oceanside .hero__title {
  font-size: clamp(48px, 6vw, 72px);
  font-weight: 300;
  line-height: 1.1;
  margin: 0 0 20px 0;
  color: #4fc3f7;
  text-transform: uppercase;
  letter-spacing: 3px;
  animation: slideInLeft 1s ease-out 0.3s both;
}

.hero--oceanside .hero__subtitle {
  font-size: 20px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0 0 40px 0;
  opacity: 0.9;
  animation: slideInLeft 1s ease-out 0.5s both;
}

/* Button */
.hero--oceanside .hero__button {
  display: inline-block;
  background: transparent;
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 15px 30px;
  border: 2px solid white;
  transition: all 0.3s ease;
  animation: slideInLeft 1s ease-out 0.7s both;
}

.hero--oceanside .hero__button:hover {
  background: white;
  color: #333;
  text-decoration: none;
}

/* Booking Form */
.hero__booking-form {
  flex: 0 0 420px;
  max-width: 420px;
  animation: slideInRight 1s ease-out 0.4s both;
}

.booking-form {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  padding: 50px 40px;
  box-shadow:
    0 25px 50px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.booking-form__header {
  text-align: center;
  margin-bottom: 30px;
}

.booking-form__title {
  font-size: 28px;
  font-weight: 700;
  color: #1a365d;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #1a365d 0%, #2d5a87 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.booking-form__subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.booking-form__form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.booking-form__row {
  display: flex;
  gap: 15px;
}

.booking-form__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.booking-form__field label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 15px;
  font-size: 16px;
  z-index: 2;
  opacity: 0.6;
}

.form-input,
.form-select {
  width: 100%;
  padding: 15px 20px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.9);
  color: #374151;
}

.form-input--with-icon,
.form-select {
  padding-left: 50px;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #4fc3f7;
  box-shadow:
    0 0 0 3px rgba(79, 195, 247, 0.1),
    0 4px 12px rgba(79, 195, 247, 0.15);
  background: white;
}

.form-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.form-select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 16px;
  padding-right: 40px;
}

.booking-form__submit {
  background: linear-gradient(135deg, #4fc3f7 0%, #29b6f6 100%);
  color: white;
  border: none;
  padding: 18px 30px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 8px 20px rgba(79, 195, 247, 0.3);
}

.booking-form__submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(79, 195, 247, 0.4);
}

.booking-form__submit:active {
  transform: translateY(-1px);
}

.booking-form__submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.booking-form__submit--loading {
  pointer-events: none;
}

.button-icon {
  font-size: 18px;
}

.loading-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Animations */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Mobile Responsive */
@media (max-width: 1024px) {
  .hero--oceanside .hero__container {
    flex-direction: column;
    gap: 50px;
    padding: 60px 20px;
    text-align: center;
  }

  .hero--oceanside .hero__content {
    max-width: 100%;
  }

  .hero__booking-form {
    flex: none;
    max-width: 500px;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .hero--oceanside {
    min-height: auto;
  }

  .hero--oceanside .hero__container {
    padding: 50px 15px;
    gap: 40px;
    min-height: auto;
  }

  .hero--oceanside .hero__title {
    font-size: clamp(32px, 8vw, 48px);
    margin-bottom: 15px;
  }

  .hero--oceanside .hero__subtitle {
    font-size: 16px;
    margin-bottom: 25px;
  }

  .booking-form {
    padding: 40px 25px;
  }

  .booking-form__title {
    font-size: 22px;
    margin-bottom: 6px;
  }

  .booking-form__subtitle {
    font-size: 13px;
  }

  .booking-form__header {
    margin-bottom: 25px;
  }

  .booking-form__row {
    flex-direction: column;
    gap: 20px;
  }

  .form-input,
  .form-select {
    padding: 12px 15px;
  }

  .form-input--with-icon {
    padding-left: 45px;
  }

  .input-icon {
    left: 12px;
    font-size: 14px;
  }

  .booking-form__submit {
    padding: 15px 25px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .hero--oceanside .hero__container {
    padding: 40px 15px;
  }

  .hero--oceanside .hero__title {
    font-size: clamp(24px, 10vw, 36px);
    letter-spacing: 1px;
  }

  .hero--oceanside .hero__subtitle {
    font-size: 14px;
  }

  .hero--oceanside .hero__button {
    padding: 12px 20px;
    font-size: 14px;
  }

  .booking-form {
    padding: 35px 20px;
  }

  .booking-form__title {
    font-size: 18px;
  }
}

/* Advanced Effects */
.hero__media::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Fish-themed gradient overlay */
.hero--fish-theme .hero__overlay {
  background: linear-gradient(
    135deg,
    rgba(0, 86, 179, 0.6) 0%,
    rgba(0, 123, 255, 0.4) 30%,
    rgba(13, 71, 161, 0.5) 70%,
    rgba(25, 118, 210, 0.6) 100%
  );
}

/* New Hero Component Styles */
.hero {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.hero-background::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
}

.hero-content {
  position: relative;
  z-index: 3;
  text-align: center;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.hero-subtitle {
  font-size: 1.5rem;
  font-weight: 300;
  margin-bottom: 1.5rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.hero-description {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

/* Booking Buttons */
.booking-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.booking-btn {
  padding: 15px 30px;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Icon styles removed - no longer needed */

.simple-booking-btn {
  background: #ff7a00;
  color: white;
  border: 2px solid #ff7a00;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(255, 122, 0, 0.3);
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 15px 40px;
}

.simple-booking-btn:hover {
  filter: brightness(1.1);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* Hero Button (existing) */
.hero-button {
  display: inline-block;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  text-decoration: none;
  border: 2px solid white;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.hero-button:hover {
  background: white;
  color: #333;
  transform: translateY(-2px);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #999;
  line-height: 1;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #333;
}

.modal-content h3 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  text-align: center;
}

/* Booking Form in Modal */
.booking-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  background: #f9f9f9;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.submit-button {
  padding: 15px 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.2rem;
  }

  .hero-description {
    font-size: 1rem;
  }

  .booking-buttons {
    flex-direction: column;
    align-items: center;
  }

  .booking-btn {
    width: 100%;
    max-width: 250px;
    font-size: 0.95rem;
    padding: 12px 25px;
  }

  .simple-booking-btn {
    font-size: 0.95rem;
    padding: 12px 25px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .modal-content {
    margin: 1rem;
    padding: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB;;sCAEoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB;;uCAEqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAmP;EACnP,sCAAsC;EACtC,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX;;;;;GAKC;EACD,8BAA8B;AAChC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,iCAAiC;AACjC;EACE;;;;;;GAMC;AACH;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,2CAA2C;;AAE3C;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* Oceanside Hero Component Styles */\n.hero--oceanside {\n  position: relative;\n  width: 100%;\n  min-height: 700px;\n  overflow: hidden;\n  background-color: #000;\n  display: flex;\n  align-items: center;\n  padding: 60px 0;\n}\n\n/* Background Media */\n.hero--oceanside .hero__media {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.hero--oceanside .hero__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.hero--oceanside .hero__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    rgba(0, 0, 0, 0.8) 0%,\n    rgba(0, 0, 0, 0.6) 50%,\n    rgba(0, 0, 0, 0.3) 100%\n  );\n  z-index: 2;\n}\n\n/* Container */\n.hero--oceanside .hero__container {\n  position: relative;\n  z-index: 3;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 80px 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 60px;\n  min-height: 600px;\n}\n\n/* Left Content */\n.hero--oceanside .hero__content {\n  flex: 1;\n  max-width: 600px;\n  text-align: left;\n}\n\n/* Typography */\n.hero--oceanside .hero__title {\n  font-size: clamp(48px, 6vw, 72px);\n  font-weight: 300;\n  line-height: 1.1;\n  margin: 0 0 20px 0;\n  color: #4fc3f7;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  animation: slideInLeft 1s ease-out 0.3s both;\n}\n\n.hero--oceanside .hero__subtitle {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 1.4;\n  margin: 0 0 40px 0;\n  opacity: 0.9;\n  animation: slideInLeft 1s ease-out 0.5s both;\n}\n\n/* Button */\n.hero--oceanside .hero__button {\n  display: inline-block;\n  background: transparent;\n  color: white;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  padding: 15px 30px;\n  border: 2px solid white;\n  transition: all 0.3s ease;\n  animation: slideInLeft 1s ease-out 0.7s both;\n}\n\n.hero--oceanside .hero__button:hover {\n  background: white;\n  color: #333;\n  text-decoration: none;\n}\n\n/* Booking Form */\n.hero__booking-form {\n  flex: 0 0 420px;\n  max-width: 420px;\n  animation: slideInRight 1s ease-out 0.4s both;\n}\n\n.booking-form {\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(15px);\n  border-radius: 20px;\n  padding: 50px 40px;\n  box-shadow:\n    0 25px 50px rgba(0, 0, 0, 0.25),\n    0 0 0 1px rgba(255, 255, 255, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.booking-form__header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.booking-form__title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a365d;\n  margin: 0 0 8px 0;\n  background: linear-gradient(135deg, #1a365d 0%, #2d5a87 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.booking-form__subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n  font-weight: 400;\n}\n\n.booking-form__form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.booking-form__row {\n  display: flex;\n  gap: 15px;\n}\n\n.booking-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n}\n\n.booking-form__field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 15px;\n  font-size: 16px;\n  z-index: 2;\n  opacity: 0.6;\n}\n\n.form-input,\n.form-select {\n  width: 100%;\n  padding: 15px 20px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.9);\n  color: #374151;\n}\n\n.form-input--with-icon,\n.form-select {\n  padding-left: 50px;\n}\n\n.form-input:focus,\n.form-select:focus {\n  outline: none;\n  border-color: #4fc3f7;\n  box-shadow:\n    0 0 0 3px rgba(79, 195, 247, 0.1),\n    0 4px 12px rgba(79, 195, 247, 0.15);\n  background: white;\n}\n\n.form-input::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.form-select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 12px center;\n  background-repeat: no-repeat;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\n.booking-form__submit {\n  background: linear-gradient(135deg, #4fc3f7 0%, #29b6f6 100%);\n  color: white;\n  border: none;\n  padding: 18px 30px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-shadow: 0 8px 20px rgba(79, 195, 247, 0.3);\n}\n\n.booking-form__submit:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 30px rgba(79, 195, 247, 0.4);\n}\n\n.booking-form__submit:active {\n  transform: translateY(-1px);\n}\n\n.booking-form__submit:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.booking-form__submit--loading {\n  pointer-events: none;\n}\n\n.button-icon {\n  font-size: 18px;\n}\n\n.loading-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Animations */\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 1024px) {\n  .hero--oceanside .hero__container {\n    flex-direction: column;\n    gap: 50px;\n    padding: 60px 20px;\n    text-align: center;\n  }\n\n  .hero--oceanside .hero__content {\n    max-width: 100%;\n  }\n\n  .hero__booking-form {\n    flex: none;\n    max-width: 500px;\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero--oceanside {\n    min-height: auto;\n  }\n\n  .hero--oceanside .hero__container {\n    padding: 50px 15px;\n    gap: 40px;\n    min-height: auto;\n  }\n\n  .hero--oceanside .hero__title {\n    font-size: clamp(32px, 8vw, 48px);\n    margin-bottom: 15px;\n  }\n\n  .hero--oceanside .hero__subtitle {\n    font-size: 16px;\n    margin-bottom: 25px;\n  }\n\n  .booking-form {\n    padding: 40px 25px;\n  }\n\n  .booking-form__title {\n    font-size: 22px;\n    margin-bottom: 6px;\n  }\n\n  .booking-form__subtitle {\n    font-size: 13px;\n  }\n\n  .booking-form__header {\n    margin-bottom: 25px;\n  }\n\n  .booking-form__row {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .form-input,\n  .form-select {\n    padding: 12px 15px;\n  }\n\n  .form-input--with-icon {\n    padding-left: 45px;\n  }\n\n  .input-icon {\n    left: 12px;\n    font-size: 14px;\n  }\n\n  .booking-form__submit {\n    padding: 15px 25px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero--oceanside .hero__container {\n    padding: 40px 15px;\n  }\n\n  .hero--oceanside .hero__title {\n    font-size: clamp(24px, 10vw, 36px);\n    letter-spacing: 1px;\n  }\n\n  .hero--oceanside .hero__subtitle {\n    font-size: 14px;\n  }\n\n  .hero--oceanside .hero__button {\n    padding: 12px 20px;\n    font-size: 14px;\n  }\n\n  .booking-form {\n    padding: 35px 20px;\n  }\n\n  .booking-form__title {\n    font-size: 18px;\n  }\n}\n\n/* Advanced Effects */\n.hero__media::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.3),\n    transparent\n  );\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n/* Fish-themed gradient overlay */\n.hero--fish-theme .hero__overlay {\n  background: linear-gradient(\n    135deg,\n    rgba(0, 86, 179, 0.6) 0%,\n    rgba(0, 123, 255, 0.4) 30%,\n    rgba(13, 71, 161, 0.5) 70%,\n    rgba(25, 118, 210, 0.6) 100%\n  );\n}\n\n/* New Hero Component Styles */\n.hero {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.hero-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.hero-bg-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.hero-background::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 2;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 3;\n  text-align: center;\n  padding: 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.hero-title {\n  font-size: 3.5rem;\n  font-weight: bold;\n  margin-bottom: 1rem;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\n}\n\n.hero-subtitle {\n  font-size: 1.5rem;\n  font-weight: 300;\n  margin-bottom: 1.5rem;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);\n}\n\n.hero-description {\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);\n}\n\n/* Booking Buttons */\n.booking-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.booking-btn {\n  padding: 15px 30px;\n  font-size: 1rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-width: 150px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* Icon styles removed - no longer needed */\n\n.simple-booking-btn {\n  background: #ff7a00;\n  color: white;\n  border: 2px solid #ff7a00;\n  font-size: 1.1rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  box-shadow: 0 4px 15px rgba(255, 122, 0, 0.3);\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 15px 40px;\n}\n\n.simple-booking-btn:hover {\n  filter: brightness(1.1);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Hero Button (existing) */\n.hero-button {\n  display: inline-block;\n  padding: 12px 24px;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  text-decoration: none;\n  border: 2px solid white;\n  border-radius: 4px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.hero-button:hover {\n  background: white;\n  color: #333;\n  transform: translateY(-2px);\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  color: #999;\n  line-height: 1;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close:hover {\n  color: #333;\n}\n\n.modal-content h3 {\n  color: #333;\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  text-align: center;\n}\n\n/* Booking Form in Modal */\n.booking-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n  background: #f9f9f9;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.submit-button {\n  padding: 15px 30px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 2.5rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1.2rem;\n  }\n\n  .hero-description {\n    font-size: 1rem;\n  }\n\n  .booking-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .booking-btn {\n    width: 100%;\n    max-width: 250px;\n    font-size: 0.95rem;\n    padding: 12px 25px;\n  }\n\n  .simple-booking-btn {\n    font-size: 0.95rem;\n    padding: 12px 25px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-content {\n    margin: 1rem;\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
